import { ReactNode } from "react"

export interface IfProps {
    children: ReactNode
    condition: boolean
    otherwise?: ReactNode
}
export const If = ({ children, condition, otherwise = null }: IfProps) => {
    return condition ? <>{children}</> : <>{otherwise}</>
}